<template>
    <div class="user_content">
        <!-- 搜索 -->
        <div class="seach">
            <!-- <div class="seach_input">
                <input type="text" placeholder="输入搜索内容">
                <div class="seach_img">
                    <img src="~@/assets/images/pagin/sarch_icon.png" alt="">
                </div>
            </div> -->
            <!-- <el-search :bSearch.sync="bSearch" @searchForm="getSearchForm"></el-search> -->
            <resultFilter @searchForm="getSearchForm"></resultFilter>
            <!-- <div class="develop" @click="bSearch = !bSearch">
                {{bSearch?'确认':'展开筛选'}}
                <img v-if="bSearch" src="~@/assets/images/pagin/send_down_green_icon.png" alt="">
                <img v-if="!bSearch" src="~@/assets/images/pagin/send_down_icon.png" alt="">
            </div> -->
        </div>

        <div class="user_warp_content">
            <div class="user_warp">
                <div class="user_title">全旅程在线状态</div>
                <div class="percentage">
                    <div class="percentage_warp_list" v-for="(item,index) in arrPercentage" :key="index">
                        <div class="warp_item">
                            <div class="rate">{{item.name}}</div>
                            <div class="rate_num">{{item.num}}</div>
                        </div>
                    </div>
                </div>
                <!-- 完成列表 -->
                <div class="complete">
                    <div class="complete_item">待完成</div>
                    <div class="complete_item">已完成</div>
                </div>
                <div class="plete_list">
                    <div class="plete_item" v-for="(item,index) in arrCustomer" :key="index">
                        <div class="plete_title">{{item.name}}</div>
                        <div class="plete_content_warp">
                            <div class="plete_content_list">
                                <div class="plete_content_item" v-for="item in 5" :key="item"></div>
                            </div>
                            <div class="speed">
                                <div class="speed_rate speed_rate_left"
                                    :style="{'width':(Number(getNumber(item.nofulfil))/(Number(getNumber(item.fulfil))+Number(item.nofulfil)))*100+'%','padding-right':item.nofulfil !=0?'':'0'}">{{item.nofulfil}}
                                </div>
                                <div class="speed_rate speed_rate_right"
                                    :style="{'width':(Number(getNumber(item.fulfil))/(Number(getNumber(item.fulfil))+Number(item.nofulfil)))*100+'%','padding-right':getNumber(item.fulfil) !=0?'':'0'}">{{item.fulfil}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="plete_bottm_item">
                        <div class="plete_bottm_title"></div>
                        <div class="plete_bottm_content_warp">
                            <div>0%</div>
                            <div>20%</div>
                            <div>40%</div>
                            <div>60%</div>
                            <div>80%</div>
                            <div>100%</div>
                        </div>
                    </div>
                </div>
                <div class="detailed" @click="skipDetailed">点击查看项目清单</div>
            </div>
            <!-- <div class="bottom_btn">一键导出</div> -->
        </div>

    </div>
</template>

<script>
import elSearch from "./search.vue";
import oJourneyJs from "@/js/hvac/performance/user.js"
import resultFilter from '@/components/hvac/performance/project/resultfilter.vue'

export default {
    created() {
        //$init(() => {
        //this.getJourneyIndex()
        //})
        let phone = this.$route.query.phone
        if (phone) {
            //存这个没有 因为授权完了 直接clear了 不知道怎么办
            //localStorage.setItem('phone',phone);
            this.$storage.setStorage("phone", phone);
        }
    },
    components: {
        resultFilter,
        elSearch
    },
    data() {
        return {
            bSearch: false,
            arrCustomer: [
                // { name: "潜客上线", fulfil: "80", nofulfil: "20" },
                // { name: "上门设计", fulfil: "80", nofulfil: "20" },
                // { name: "方案设计", fulfil: "60", nofulfil: "20" },
                // { name: "施工图纸", fulfil: "50", nofulfil: "20" },
                // { name: "配置报价", fulfil: "70", nofulfil: "30" },
                // { name: "合同签订", fulfil: "55", nofulfil: "30" },
                // { name: "订单下达", fulfil: "50", nofulfil: "5" },
                // { name: "订单解信", fulfil: "49", nofulfil: "1" },
                // { name: "订单排产", fulfil: "43", nofulfil: "6" },
                // { name: "订单发货", fulfil: "23", nofulfil: "20" },
                // { name: "订单签收", fulfil: "20", nofulfil: "3" },
                // { name: "设备安装", fulfil: "18", nofulfil: "2" },
                // { name: "系统监理", fulfil: "15", nofulfil: "3" },
                // { name: "设备调试", fulfil: "11", nofulfil: "4" },
                // { name: "验收交付", fulfil: "8", nofulfil: "3" },
            ],
            bShow: false,
            arrPercentage: [
                // { name: "签单率(%)", num: 78.6 },
                // { name: "合同订单转换率(%)", num: 78.6 },
                // { name: "设备安装率(%)", num: 78.6 },
                // { name: "订单交付率(%)", num: 78.6 },
            ],
            oSearchForm: {
                sStart: "",
                sEnd: ""
            },
            //搜索表单
            oSearchForm: {
                //...
                agent: "",
                area: "",
                channel: "",
                city: "",
                worker: "",
                start: "",
                end: ""
            },
        };
    },
    methods: {
        getJourneyIndex() {
            this.$store.commit("loadSwitch", true);
            let data = {
                start: this.oSearchForm.sStart,
                end: this.oSearchForm.sEnd,
                //搜索
                agent: this.oSearchForm.agent,
                area: this.oSearchForm.area,
                channel: this.oSearchForm.channel,
                city: this.oSearchForm.city,
                worker: this.oSearchForm.worker,
                start: this.oSearchForm.start,
                end: this.oSearchForm.end
            }
            oJourneyJs.getJourneyIndex(data).then(res => {
                let data = res.data.data;
                this.arrCustomer = data.result.list;
                this.arrPercentage = data.result.card;
                this.$store.commit("loadSwitch", false);
            });
        },
        getSearchForm(val) {
            this.oSearchForm = val;
            //this.oSearchForm.sStart=val.sStart
            //this.oSearchForm.sEnd=val.sEnd
            this.getJourneyIndex()
        },
        //-1 变成1
        getNumber(val) {
            if (val < 0) {
                return 0
            } else {
                return val
            }
        },
        skipDetailed() {
            // console.log("skipDetailed")
            this.$router.push({
                path: '/performance/user/detailed',
                query: {
                    agent: this.oSearchForm.agent,
                    area: this.oSearchForm.area,
                    channel: this.oSearchForm.channel,
                    city: this.oSearchForm.city,
                    worker: this.oSearchForm.worker,
                    start: this.oSearchForm.start,
                    end: this.oSearchForm.end,
                }
            })
        }
    },
};
</script>
<style lang="scss" scoped>
.user_content {
    height: 100%;
    .seach {
        width: 100%;
        background: #fff;
        padding: 0 24px 20px;

        box-sizing: border-box;
        .seach_input {
            width: 100%;
            height: 80px;
            background: #f7f7f7;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 24px;
            input {
                width: 80%;
                background: transparent;
                height: 80px;
                font-size: 28px;
            }
            .seach_img {
                width: 40px;
                height: 40px;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .develop {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 28px;
            margin-top: 20px;
            padding-top: 15px;
            img {
                width: 26px;
                height: 26px;
                transition: all 0.5s;
                margin-left: 10px;
            }
            // &::after {
            //     content: "";
            //     width: 26px;
            //     height: 26px;
            //     background: url("~@/assets/images/pagin/send_down_icon.png")
            //         no-repeat center/100%;
            // }
        }
    }
    .user_warp_content {
        padding: 24px;
        box-sizing: border-box;
        .bottom_btn {
            width: 100%;
            border-radius: 12px;
            background: linear-gradient(136deg, #4ea062 0%, #338444 100%);
            height: 92px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            font-size: 28px;
            margin-top: 32px;
        }
        .user_warp {
            width: 100%;
            background: #fff;
            border-radius: 12px;
            padding: 18px 18px;
            box-sizing: border-box;
            .detailed {
                margin-top: 32px;
                text-align: center;
                padding-bottom: 10px;
                box-sizing: border-box;
                color: #444444;
                font-size: 24px;
            }
            .user_title {
                font-size: 28px;
                font-weight: 700;
                color: #222222;
            }
            .percentage {
                width: 100%;
                margin-top: 24px;
                padding-bottom: 32px;
                border-bottom: 1px dashed #f1f1f1;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .percentage_warp_list {
                    width: 25%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .warp_item {
                        width: 90%;
                        height: 210px;
                        background: #f7f7f7;
                        border-radius: 16px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: space-between;
                        padding: 10px 0;
                        box-sizing: border-box;
                        .rate {
                            width: 85%;
                            font-size: 28px;
                            text-align: center;
                            color: #858585;
                        }
                        .rate_num {
                            font-size: 48px;
                            font-weight: 700;
                            color: $deepGreen;
                        }
                    }
                }
            }
            .complete {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                margin-top: 22px;
                .complete_item {
                    color: #858585;
                    margin-left: 48px;
                    display: flex;
                    align-items: center;
                    &:last-child::before {
                        content: "";
                        display: inline-block;
                        width: 32px;
                        height: 32px;
                        background: #8ea3ec;
                        margin-right: 8px;
                    }
                    &:first-child::before {
                        content: "";
                        display: inline-block;
                        width: 32px;
                        height: 32px;
                        background: #a2e3a9;
                        margin-right: 8px;
                    }
                }
            }
            .plete_list {
                margin-top: 24px;
                width: 100%;
                .plete_bottm_item {
                    display: flex;
                    margin-top: 15px;
                    .plete_bottm_title {
                        width: 15%;
                    }
                    .plete_bottm_content_warp {
                        display: flex;
                        width: 85%;
                        div {
                            text-align: right;
                            width: 20%;
                            color: #a2a2a2;
                        }
                    }
                }
                .plete_item {
                    width: 100%;
                    height: 70px;
                    border-left: 1px solid #a2e3a9;
                    display: flex;
                    position: relative;
                    &::before {
                        content: "";
                        display: inline-block;
                        width: 20px;
                        height: 20px;
                        border-radius: 50%;
                        border: 1px solid #a2e3a9;
                        background: #fff;
                        position: absolute;
                        left: -15px;
                        top: 18px;
                    }
                    .plete_title {
                        margin-top: 10px;
                        font-size: 28px;
                        color: #858585;
                        margin-left: 30px;
                        margin-right: 30px;
                    }
                    .plete_content_warp {
                        padding-top: 10px;
                        box-sizing: border-box;
                        // width: 80%;
                        flex: 1;
                        height: 70px;
                        position: relative;
                        .plete_content_list {
                            width: 100%;
                            position: absolute;
                            top: 0;
                            display: flex;
                            .plete_content_item {
                                width: 20%;
                                height: 70px;
                                border-left: 1px solid #f2f2f2;
                                &:last-child {
                                    border-right: 1px solid #f2f2f2;
                                }
                            }
                        }
                        .speed {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            margin-top: 10px;
                            .speed_rate {
                                position: relative;
                                z-index: 1;
                                width: 100%;
                                height: 32px;
                                transition: all 0.5s;
                                text-align: right;
                                padding-right: 10px;
                                box-sizing: border-box;
                                overflow: hidden;
                            }
                            .speed_rate_left {
                                color: #fff;
                                background: #8ea3ec;
                            }
                            .speed_rate_right {
                                background: #a2e3a9;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>